import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=fac2109a&"
import script from "./role-list.ts?vue&type=script&lang=ts&"
export * from "./role-list.ts?vue&type=script&lang=ts&"
import style0 from "./role-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports